/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_OFFICE } from '@gh/builder-shared-data';

import { createRoute } from '@gh/common-shared';

import { ChecklistListTabComponent } from './components/checklist-tab/checklist-tab.component';
import { CommunityListTabComponent } from './components/community-list-tab/community-list-tab.component';
import { ImportLeadsTabComponent } from './components/import-leads-tab/import-leads-tab.component';
import { SalesTabContainerComponent } from './components/sales-tab-container/sales-tab-container.component';
import { ChecklistListBusinessService } from './resources/checklist-business.service';
import { CommunityListBusinessService } from './resources/community-list-business.service';
import { ImportLeadsTabBusinessService } from './resources/import-leads-tab-business.service';

const routes = [
  createRoute({
    component: SalesTabContainerComponent,
    path: '',
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
    },
    children: [
      createRoute({
        component: CommunityListTabComponent,
        path: 'communities',
        init: CommunityListBusinessService,
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.Sales.Communities.LIST',
          ],
        },
      }),
      createRoute({
        component: ChecklistListTabComponent,
        path: 'complete-sales',
        init: ChecklistListBusinessService,
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.Sales.Checklist.LIST',
          ],
        },
      }),
      createRoute({
        component: ImportLeadsTabComponent,
        path: 'import-leads',
        init: ImportLeadsTabBusinessService,
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: [
            'Setup.Sales.ImportLeads.EXECUTE',
          ],
        },
      }),
    ],
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupSalesRoutingModule {
}
